{
  "PROFILE_SETTINGS": {
    "LINK": "Ρυθμίσεις Προφίλ",
    "TITLE": "Ρυθμίσεις Προφίλ",
    "BTN_TEXT": "Ενημέρωση Προφίλ",
    "DELETE_AVATAR": "Διαγραφή Avatar",
    "AVATAR_DELETE_SUCCESS": "Το Avatar διαγράφηκε με επιτυχία",
    "AVATAR_DELETE_FAILED": "Παρουσιάστηκε σφάλμα κατά τη διαγραφή του avatar, παρακαλώ προσπαθήστε ξανά",
    "UPDATE_SUCCESS": "Το προφίλ σας ενημερώθηκε επιτυχώς",
    "PASSWORD_UPDATE_SUCCESS": "Ο κωδικός σας άλλαξε με επιτυχία",
    "AFTER_EMAIL_CHANGED": "Το προφίλ σας ενημερώθηκε επιτυχώς, παρακαλώ κάντε είσοδο (login) επειδή τα στοιχεία εισόδου σας έχουν αλλάξει",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Εικόνα υπογραφής email",
        "HINT": "Χρησιμοποιείται στις υπογραφές email. Το {'{{'}email_signature_picture{'}}'} αντικαθίσταται με το URL αυτής της εικόνας (όχι με ετικέτα εικόνας) — χρησιμοποιήστε το ως πηγή εικόνας (το src μιας ετικέτας img) στην υπογραφή σας ή στην υπογραφή του φακέλου εισερχομένων. Αν δεν οριστεί, δεν εισάγεται τίποτα.",
        "DELETE_SUCCESS": "Η εικόνα υπογραφής email διαγράφηκε με επιτυχία",
        "DELETE_FAILED": "Παρουσιάστηκε σφάλμα κατά τη διαγραφή της εικόνας υπογραφής email, δοκιμάστε ξανά"
      },
      "AVATAR": "Εικόνα Προφίλ",
      "ERROR": "Παρακαλώ διορθώστε τα λάθη της φόρμας",
      "REMOVE_IMAGE": "Διαγραφή",
      "UPLOAD_IMAGE": "Ανέβασμα Εικόνας",
      "UPDATE_IMAGE": "Ενημέρωση Εικόνας",
      "PROFILE_SECTION": {
        "TITLE": "Προφίλ",
        "NOTE": "Η διεύθυνση email είναι η ταυτότητά σας και χρησιμοποιείται για την είσοδο (login) σας."
      },
      "SEND_MESSAGE": {
        "TITLE": "Πλήκτρο συντόμευσης για αποστολή μηνυμάτων",
        "NOTE": "Μπορείτε να επιλέξετε μια συντόμευση (είτε εισάγετε είτε Cmd/Ctrl+Enter) με βάση την προτίμηση για το γράψιμο.",
        "UPDATE_SUCCESS": "Οι ρυθμίσεις σας έχουν ενημερωθεί με επιτυχία",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Αποστολή μηνυμάτων πατώντας το πλήκτρο Enter αντί να πατήσετε το κουμπί αποστολής."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Αποστολή μηνυμάτων πατώντας το πλήκτρο Enter αντί να πατήσετε το κουμπί αποστολής."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Προσαρμόστε την εμφάνιση του ταμπλό σας.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Προεπιλογή",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Γλώσσα του ταμπλό",
          "NOTE": "Αντικαταστήστε τη γλώσσα του λογαριασμού για το δικό σας ταμπλό. Αφήστε κενό για χρήση της προεπιλογής του λογαριασμού.",
          "USE_ACCOUNT_DEFAULT": "Χρήση προεπιλογής λογαριασμού",
          "API_SUCCESS": "Η γλώσσα του ταμπλό σας ενημερώθηκε επιτυχώς"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Γλώσσα Μηνύματος",
          "NOTE": "Επιλέξτε αν θα εμφανίζονται τα αρχικά μηνύματα ή οι μεταφράσεις τους",
          "ORIGINAL": "Αρχικό",
          "TRANSLATED": "Μεταφρασμένο"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Συμπεριφορά Επικόλλησης",
          "NOTE": "Επιλέξτε πώς θα επεξεργάζεται το επικολλημένο περιεχόμενο κατά τη σύνταξη μηνυμάτων",
          "UPDATE_SUCCESS": "Οι ρυθμίσεις επικόλλησης ενημερώθηκαν επιτυχώς",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Διατήρηση όλης της μορφοποίησης",
              "DESCRIPTION": "Διατηρεί όλη τη μορφοποίηση, συμπεριλαμβανομένων πινάκων, στυλ και άλλων στοιχείων HTML κατά την επικόλληση περιεχομένου."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Κείμενο μόνο με συνδέσμους",
              "DESCRIPTION": "Μετατρέπει σε απλό κείμενο, διατηρώντας τους ενεργούς συνδέσμους κατά την επικόλληση περιεχομένου."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Μόνο απλό κείμενο",
              "DESCRIPTION": "Αφαιρεί όλη τη μορφοποίηση και μετατρέπει σε απλό κείμενο κατά την επικόλληση περιεχομένου."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Ύψος πλαισίου απάντησης",
          "NOTE": "Ορίστε το ελάχιστο ύψος του πλαισίου απάντησης ως ποσοστό του ύψους της οθόνης. Ισχύει μόνο για τις συνομιλίες μέσω email.",
          "UPDATE_SUCCESS": "Η ρύθμιση ύψους πλαισίου απάντησης ενημερώθηκε με επιτυχία",
          "PERCENT_LABEL": "Ύψος (% του ύψους της οθόνης)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Προεπιλογή",
              "DESCRIPTION": "Το πλαίσιο απάντησης ξεκινά μικρό και μεγαλώνει καθώς πληκτρολογείτε."
            },
            "CUSTOM": {
              "HEADING": "Προσαρμοσμένο",
              "DESCRIPTION": "Το πλαίσιο απάντησης έχει πάντα τουλάχιστον το επιλεγμένο ποσοστό του ύψους της οθόνης."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Αυτόματη μετάβαση στην επόμενη συνομιλία",
        "NOTE": "Μετάβαση αυτόματα στην επόμενη ανοιχτή συνομιλία μετά την επίλυση της τρέχουσας",
        "UPDATE_SUCCESS": "Η ρύθμιση αυτόματης μετάβασης ενημερώθηκε επιτυχώς"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Προσωπική υπογραφή μηνύματος",
        "DESCRIPTION": "Δημιουργήστε μια μοναδική υπογραφή μηνύματος που θα εμφανίζεται στο τέλος κάθε email που στέλνετε. Μπορείτε επίσης να συμπεριλάβετε μια ενσωματωμένη εικόνα.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Αποθήκευση υπογραφής μηνύματος",
        "API_ERROR": "Δεν ήταν δυνατή η αποθήκευση της υπογραφής! Δοκιμάστε ξανά",
        "API_SUCCESS": "Η υπογραφή αποθηκεύτηκε με επιτυχία",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Υπογραφή μηνύματος",
        "ERROR": "H υπογραφή μηνύματος δεν μπορεί να είναι κενή",
        "PLACEHOLDER": "Εισάγετε εδώ την προσωπική σας υπογραφή μηνύματος."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Κωδικός",
        "NOTE": "Η ενημέρωση του κωδικού κα επαναφέρει τα logins σε όλες τις συσκευές που έχετε συνδεθεί.",
        "BTN_TEXT": "Αλλαγή κωδικού πρόσβασης"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Κώδικας Πρόσβασης (Access Token)",
        "NOTE": "Χρησιμοποιείται σε περίπτωση εξωτερικής ενοποίησης της εφαρμογής με κώδικα (API)",
        "COPY": "Αντιγραφή",
        "REGENERATE": "Επαναδημιουργία",
        "REGENERATE_SUCCESS": "Ο κωδικός πρόσβασης (access token) δημιουργήθηκε εκ νέου με επιτυχία. Παρακαλώ ενημερώστε τυχόν ενοποιήσεις που χρησιμοποιούν τον παλιό κωδικό.",
        "REGENERATE_CONFIRM_TITLE": "Επαναδημιουργία κωδικού πρόσβασης (access token);",
        "REGENERATE_CONFIRM_MESSAGE": "Αυτό θα ακυρώσει τον τρέχοντα κωδικό. Τυχόν ενοποιήσεις που χρησιμοποιούν τον παλιό κωδικό θα σταματήσουν να λειτουργούν."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Επέκταση Chrome",
        "NOTE": "Εγκαταστήστε την επέκταση chrome μας για να λαμβάνετε πλούσιες ειδοποιήσεις για εισερχόμενες τηλεφωνικές κλήσεις.",
        "INSTALL_BUTTON": "Εγκατάσταση επέκτασης",
        "ALREADY_INSTALLED": "Η επέκταση εγκαταστάθηκε"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Κανένα",
          "MINE": "Assigned",
          "ALL": "Όλες",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Κανένα",
          "ASSIGNED": "Ανατεθειμένες Συνομιλίες",
          "ALL_CONVERSATIONS": "Όλες Οι Συνομιλίες"
        },
        "DEFAULT_TONE": {
          "TITLE": "Ήχος προειδοποίησης:"
        },
        "CONDITIONS": {
          "TITLE": "Συνθήκες προειδοποίησης:",
          "CONDITION_ONE": "Αποστολή ειδοποιήσεων ήχου μόνο αν το παράθυρο του προγράμματος περιήγησης δεν είναι ενεργό",
          "CONDITION_TWO": "Ειδοποίηση κάθε 30s μέχρι να διαβαστούν όλες οι αντιστοιχισμένες συνομιλίες"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Ειδοποιήσεις Email",
        "NOTE": "Ενημέρωστε την προτίμηση για ειδοποιήσεις με email εδώ",
        "CONVERSATION_ASSIGNMENT": "Να στέλνεται ειδοποίηση email όταν μια συνομιλία αντιστοιχίζεται σε μένα",
        "CONVERSATION_CREATION": "Να στέλνεται ειδοποίηση όταν δημιουργείται μια νέα συνομιλία",
        "CONVERSATION_MENTION": "Αποστολή ειδοποιήσεων email όταν αναφέρεστε σε μια συνομιλία",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Αποστολή ειδοποίησης email όταν ένα νέο μήνυμα δημιουργείται σε συνομιλία που έχει αναληφθεί",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "Email",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Δημιουργείται νέο μήνυμα σε συνομιλία χωρίς διαθέσιμο πράκτορα",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Να επιτρέπονται οι ειδοποιήσεις push κατά τη διάρκεια κλήσης",
        "TEST_PUSH": "Δοκιμή",
        "TESTING": "Δοκιμή...",
        "TEST_PUSH_DESCRIPTION": "Στείλτε δοκιμαστικές ειδοποιήσεις για να επαληθεύσετε τη ρύθμισή σας",
        "TEST_NOTIFICATION_ERROR": "Αποτυχία αποστολής δοκιμαστικής ειδοποίησης. Παρακαλώ προσπαθήστε ξανά.",
        "TEST_LOCAL_TITLE": "Δοκιμαστική Ειδοποίηση (Τοπική)",
        "TEST_LOCAL_BODY": "Αυτή είναι μια τοπική ειδοποίηση προγράμματος περιήγησης. Αν τη βλέπετε, οι ειδοποιήσεις προγράμματος περιήγησης λειτουργούν!"
      },
      "API": {
        "UPDATE_SUCCESS": "Οι προτιμήσεις σας για τις ειδοποιήσεις ενημερώθηκαν",
        "UPDATE_ERROR": "Παρουσιάστηκε σφάλμα κατά την ενημέρωση των προτιμήσεων προσπαθήστε ξανά"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Ειδοποιήσεις Push",
        "NOTE": "Ενημερώστε τις ρυθμίσεις για τις push ειδοποιήσεις εδώ",
        "CONVERSATION_ASSIGNMENT": "Να ειδοποιούμαι με push όταν μια συνομιλία μου ανατείθεται",
        "CONVERSATION_CREATION": "Να ειδοποιούμαι με push όταν δημιουργείται μια νέα συνομιλία",
        "CONVERSATION_MENTION": "Αποστολή ειδοποιήσεων push όταν αναφέρεστε σε μια συνομιλία",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Αποστολή ειδοποίησης push όταν ένα νέο μήνυμα δημιουργείται σε συνομιλία που έχει αναληφθεί",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Έχετε ενεργοποιήσει τις ειδοποιήσεις push για αυτόν τον browser.",
        "REQUEST_PUSH": "Ενεργοποποίηση των ειδοποιήσεων push",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Εικόνα Προφίλ"
      },
      "NAME": {
        "LABEL": "Το πλήρες σας όνομα",
        "ERROR": "Παρακαλώ εισάγετε ένα έγκυρο πλήρες όνομα",
        "PLACEHOLDER": "Παρακαλώ συμπληρώστε το πλήρες όνομα σας"
      },
      "DISPLAY_NAME": {
        "LABEL": "Εμφανιζόμενο όνομα",
        "ERROR": "Παρακαλώ συμπληρώστε έγκυρο εμφανιζόμενο όνομα",
        "PLACEHOLDER": "Παρακαλώ συμπληρώστε το όνομα που θα εμφανίζεται στις συνομιλίες"
      },
      "POSITION": {
        "LABEL": "Θέση",
        "ERROR": "Παρακαλώ εισάγετε μια έγκυρη θέση",
        "PLACEHOLDER": "Παρακαλώ εισάγετε τη θέση σας"
      },
      "CUSTOM_LINE": {
        "LABEL": "Προσαρμοσμένη γραμμή",
        "ERROR": "Παρακαλώ εισάγετε μια έγκυρη προσαρμοσμένη γραμμή",
        "PLACEHOLDER": "Παρακαλώ εισάγετε την προσαρμοσμένη γραμμή σας"
      },
      "AVAILABILITY": {
        "LABEL": "Διαθεσιμότητα",
        "STATUS": {
          "ONLINE": "Στην Γραμμή",
          "BUSY": "Απασχολημένος",
          "OFFLINE": "Εκτός"
        },
        "SET_AVAILABILITY_SUCCESS": "Η διαθεσιμότητα ορίστηκε με επιτυχία",
        "SET_AVAILABILITY_ERROR": "Αδυναμία ορισμού διαθεσιμότητας, παρακαλώ προσπαθήστε ξανά"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Μορφή προεπισκόπησης email στη λίστα συνομιλιών",
        "NOTE": "Επιλέξτε τι εμφανίζεται στη λίστα συνομιλιών για συνομιλίες από γραμματοκιβώτια email",
        "SUBJECT": "Θέμα",
        "SUBJECT_WITH_NOTE": "Θέμα και το τελευταίο μήνυμα, αν είναι ιδιωτική σημείωση",
        "UPDATE_SUCCESS": "Η ρύθμιση προεπισκόπησης email ενημερώθηκε με επιτυχία"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Απενεργοποίηση συντομεύσεων πληκτρολογίου",
        "NOTE": "Απενεργοποιεί όλες τις συντομεύσεις πληκτρολογίου σε ολόκληρη την εφαρμογή",
        "UPDATE_SUCCESS": "Η ρύθμιση συντομεύσεων πληκτρολογίου ενημερώθηκε επιτυχώς"
      },
      "FOLDER_ORDER": {
        "TITLE": "Σειρά Φακέλων",
        "NOTE": "Προσαρμόστε τη σειρά με την οποία εμφανίζονται οι φάκελοι (προσαρμοσμένες προβολές) στην πλευρική μπάρα. Σύρετε και αφήστε για αναδιάταξη.",
        "NO_FOLDERS": "Δεν βρέθηκαν προσαρμοσμένοι φάκελοι. Δημιουργήστε φακέλους για να οργανώσετε τις συνομιλίες σας."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Διαμόρφωση Πλευρικής Μπάρας",
        "NOTE": "Προσαρμόστε ποιες ενότητες εμφανίζονται στην πλευρική μπάρα συνομιλιών.",
        "SAVE_BUTTON": "Αποθήκευση Διαμόρφωσης",
        "UPDATE_SUCCESS": "Η διαμόρφωση πλευρικής μπάρας ενημερώθηκε επιτυχώς",
        "UPDATE_ERROR": "Παρουσιάστηκε σφάλμα κατά την ενημέρωση της διαμόρφωσης πλευρικής μπάρας, παρακαλώ προσπαθήστε ξανά",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Όλες Οι Συνομιλίες",
          "ALL_CONVERSATIONS_DESC": "Εμφάνιση του στοιχείου μενού Όλες Οι Συνομιλίες στην πλευρική μπάρα",
          "INBOX": "Εισερχόμενα",
          "INBOX_DESC": "Εμφάνιση του κύριου κιβωτίου εισερχομένων με μη αναγνωσμένες ειδοποιήσεις",
          "CONVERSATION_GROUPS": "Αναφορές και Χωρίς Παρακολούθηση",
          "CONVERSATION_GROUPS_DESC": "Εμφάνιση των ομάδων συνομιλιών Αναφορές και Χωρίς Παρακολούθηση",
          "FOLDERS": "Φάκελοι",
          "FOLDERS_DESC": "Εμφάνιση προσαρμοσμένων προβολών (φακέλων) για οργανωμένες συνομιλίες",
          "TEAMS": "Ομάδες",
          "TEAMS_DESC": "Εμφάνιση συνομιλιών φιλτραρισμένων κατά ανάθεση ομάδας",
          "CHANNELS": "Κιβώτια Εισερχομένων",
          "CHANNELS_DESC": "Εμφάνιση συνομιλιών φιλτραρισμένων κατά κιβώτιο εισερχομένων",
          "LABELS": "Ετικέτες",
          "LABELS_DESC": "Εμφάνιση συνομιλιών φιλτραρισμένων κατά ετικέτες"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Ρυθμίσεις τηλεφώνου",
        "NOTE": "Εισάγετε τα διαπιστευτήρια σύνδεσης στο σύστημα PBX σας.",
        "USERNAME": "Όνομα χρήστη",
        "PASSWORD": "Κωδικός πρόσβασης",
        "SUBMIT": "Αποθήκευση",
        "USERNAME_INVALID": "Το όνομα χρήστη μπορεί να περιέχει μόνο γράμματα, ψηφία και . _ - + — χωρίς κενά και χωρίς διεύθυνση email.",
        "API": {
          "USERNAME_INVALID": "Το όνομα χρήστη δεν είναι έγκυρο όνομα χρήστη SIP. Χρησιμοποιήστε μόνο γράμματα, ψηφία και . _ - + — χωρίς κενά και χωρίς διεύθυνση email.",
          "USERNAME_TAKEN": "Αυτό το όνομα χρήστη χρησιμοποιείται ήδη από άλλον πράκτορα σε αυτόν τον λογαριασμό."
        }
      },
      "EMAIL": {
        "LABEL": "Η διεύθυνση email",
        "ERROR": "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email",
        "PLACEHOLDER": "Εισάγετε το Email σας, όπως θα εμφανίζεται στις συνομιλίες σας"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Τρέχων κωδικός πρόσβασης",
        "ERROR": "Παρακαλώ εισάγετε τον τρέχοντα κωδικό πρόσβασης",
        "PLACEHOLDER": "Παρακαλώ εισάγετε τον τρέχοντα κωδικό πρόσβασης"
      },
      "PASSWORD": {
        "LABEL": "Νέος κωδικός πρόσβασης",
        "ERROR": "Παρακαλώ εισάγετε κωδικό τουλάχιστον 6 χαρακτήρων",
        "PLACEHOLDER": "Παρακαλώ εισάγετε ένα νέο κωδικό (password)"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Επιβεβαίωση νέου κωδικού",
        "ERROR": "Η Επιβεβαίωση κωδικού θα πρέπει να ταιριάζει με τον κωδικό",
        "PLACEHOLDER": "Παρακαλώ εισάγετε ξανά τον νέο κωδικό (password)"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Να αλλάξει",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Αναφορά σφάλματος",
    "SELECTOR_SUBTITLE": "Επιλέξτε ένα λογαριασμό από την Λίστα",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Αναφορά σφάλματος",
    "DESCRIPTION_LABEL": "Περιγραφή Προβλήματος",
    "DESCRIPTION_PLACEHOLDER": "Περιγράψτε το πρόβλημα που αντιμετωπίσατε...",
    "SUBMIT": "Υποβολή αναφοράς",
    "SUBMITTING": "Υποβολή...",
    "CANCEL": "Άκυρο",
    "SUCCESS": "Η αναφορά σφάλματος υποβλήθηκε επιτυχώς. Ευχαριστούμε!",
    "VALIDATION_ERROR": "Παρακαλώ περιγράψτε το πρόβλημα πριν την υποβολή"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "ημέρες δοκιμαστικής περιόδου απομένουν.",
    "TRAIL_BUTTON": "Αγόρασε τώρα",
    "DELETED_USER": "Διαγραμμένος Χρήστης",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Αναστολή Λογαριασμού",
      "MESSAGE": "Ο λογαριασμός σας έχει ανασταλεί. Επικοινωνήστε με την ομάδα υποστήριξης για περισσότερες πληροφορίες."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Αντιγραφή",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Ο κώδικας αντιγράφτηκε με επιτυχία στο πρόχειρο"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Εμφάνιση Περισσότερων",
      "SHOW_LESS": "Εμφάνιση Λιγότερων"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Κατέβασμα",
      "UPLOADING": "Ανέβασμα ...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Η ιστορία δεν είναι πλέον διαθέσιμη.",
      "RECORDING_UNAVAILABLE": "Αυτή η ηχογράφηση δεν είναι πλέον διαθέσιμη.",
      "DELETE_RECORDING": {
        "BUTTON": "Διαγραφή ηχογράφησης κλήσης",
        "TITLE": "Διαγραφή της ηχογράφησης κλήσης;",
        "DESCRIPTION": "Όλες οι ηχογραφήσεις αυτής της κλήσης θα διαγραφούν οριστικά από το τηλεφωνικό σύστημα και δεν μπορούν να ανακτηθούν. Η απομαγνητοφώνηση και η περίληψη της κλήσης παραμένουν.",
        "CONFIRM": "Διαγραφή",
        "SUCCESS": "Η ηχογράφηση κλήσης διαγράφηκε",
        "ERROR": "Δεν ήταν δυνατή η διαγραφή της ηχογράφησης κλήσης. Δοκιμάστε ξανά."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Δείτε στον χάρτη"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Καταχώρηση"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Επιβεβαίωση...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Προσθήκη Κιβωτίου"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Τρέχουσα προβολή:",
    "SWITCH": "Εναλλαγή",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Συζητήσεις",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Όλες Οι Συνομιλίες",
    "MENTIONED_CONVERSATIONS": "Αναφορές",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Χωρίς Παρακολούθηση",
    "REPORTS": "Αναφορές",
    "SETTINGS": "Ρυθμίσεις",
    "CONTACTS": "Επαφές",
    "DATA_ASSISTANT": "Βοηθός Δεδομένων",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Αρχική",
    "AGENTS": "Πράκτορες",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "Πρότυπα WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Κιβώτια Εισερχομένων",
    "NOTIFICATIONS": "Ειδοποιήσεις",
    "CANNED_RESPONSES": "Έτοιμες Απαντήσεις",
    "INTEGRATIONS": "Ενοποιήσεις",
    "PROFILE_SETTINGS": "Ρυθμίσεις Προφίλ",
    "ACCOUNT_SETTINGS": "Ρυθμίσεις Λογαριασμού",
    "APPLICATIONS": "Εφαρμογές",
    "LABELS": "Ετικέτες",
    "CUSTOM_ATTRIBUTES": "Προσαρμοζόμενες Ιδιότητες",
    "AUTOMATION": "Αυτοματισμός",
    "MACROS": "Μακροεντολές",
    "TEAMS": "Ομάδες",
    "BILLING": "Χρεώσεις",
    "CUSTOM_VIEWS_FOLDER": "Φάκελοι",
    "CUSTOM_VIEWS_SEGMENTS": "Τμήματα",
    "ALL_CONTACTS": "Όλες Οι Επαφές",
    "TAGGED_WITH": "Ετικέτα με",
    "NEW_LABEL": "Νέα ετικέτα",
    "NEW_TEAM": "Νέα ομάδα",
    "NEW_INBOX": "Νέο Κιβώτιο εισερχόμενων",
    "REPORTS_CONVERSATION": "Συζητήσεις",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Καμπάνιες",
    "ONGOING": "Σε Εξέλιξη",
    "ONE_OFF": "Ένα/μία από",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Πράκτορες",
    "REPORTS_LABEL": "Ετικέτες",
    "REPORTS_INBOX": "Εισερχόμενα",
    "REPORTS_TEAM": "Ομάδα",
    "REPORTS_PHONE": "Τηλέφωνο",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Επισκόπηση",
    "WALLBOARD_QUEUES": "Ουρές",
    "DATA_ASSISTANT_CHAT": "Συνομιλία",
    "DATA_ASSISTANT_REPORTS": "Αναφορές",
    "NO_WAITING_CALLERS": "κανένας καλών σε αναμονή",
    "WAITING_CALLERS": "{count} καλούντες σε αναμονή",
    "SET_AVAILABILITY_TITLE": "Ορίστε τον εαυτό σας ως",
    "SET_YOUR_AVAILABILITY": "Ορίστε τη διαθεσιμότητά σας",
    "AVAILABILITY_IMPERSONATING": "Κλειδωμένο όσο είστε συνδεδεμένοι ως αυτός ο χρήστης",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Νέα συνομιλία",
    "DRAFT": "Πρόχειρο",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Επισκόπηση",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Κατηγορίες",
      "LOCALES": "Γλώσσες",
      "SETTINGS": "Ρυθμίσεις",
      "DICTIONARY": "Λεξικό"
    },
    "CHANNELS": "Channels",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Αυτόματη σήμανση εκτός σύνδεσης",
      "INFO_TEXT": "Αφήστε το σύστημα να σας σηματοδοτήσει αυτόματα εκτός σύνδεσης, όταν δεν χρησιμοποιείτε την εφαρμογή ή τον πίνακα ελέγχου.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Ανάγνωση εγγράφων"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Αποκλεισμένα domains και επαφές",
    "DESCRIPTION": "Λίστα αποκλεισμένων domains email για αυτόν τον λογαριασμό.",
    "NO_BLOCKED_DOMAINS": "Δεν βρέθηκαν αποκλεισμένα domains.",
    "BLOCKED_CONTACTS_BTN": "Αποκλεισμένες Επαφές"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Χρεώσεις",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Τρέχον Πλάνο",
      "PLAN_NOTE": "Αυτή τη στιγμή έχετε εγγραφεί στο πλάνο **{plan}** με **{quantity}** άδειες",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Διαχειριστείτε τη συνδρομή σας",
      "DESCRIPTION": "Δείτε τα προηγούμενα τιμολόγια σας, επεξεργαστείτε τα στοιχεία χρέωσης ή ακυρώστε τη συνδρομή σας.",
      "BUTTON_TXT": "Μετάβαση στην πύλη χρέωσης"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Χρειάζεστε βοήθεια;",
      "DESCRIPTION": "Αντιμετωπίζετε οποιαδήποτε προβλήματα στην τιμολόγηση? Είμαστε εδώ για να βοηθήσουμε.",
      "BUTTON_TXT": "Συνομιλήστε μαζί μας"
    },
    "NO_BILLING_USER": "Ο λογαριασμός χρέωσης έχει ρυθμιστεί. Παρακαλώ ανανεώστε τη σελίδα και προσπαθήστε ξανά."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ωχ! Δεν μπορέσαμε να βρούμε κανένα λογαριασμό. Παρακαλούμε δημιουργήστε ένα νέο λογαριασμό για να συνεχίσετε.",
    "NEW_ACCOUNT": "Νέος Λογαριασμός",
    "SELECTOR_SUBTITLE": "Δημιουργία νέου Λογαριασμού",
    "API": {
      "SUCCESS_MESSAGE": "Ο Λογαριασμός δημιουργήθηκε επιτυχώς",
      "EXIST_MESSAGE": "Ο Λογαριασμός υπάρχει ήδη",
      "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Όνομα Εταιρείας",
        "PLACEHOLDER": "Wayne Α. Ε"
      },
      "SUBMIT": "Καταχώρηση",
      "CANCEL": "Άκυρο"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Εμφάνιση όλων των συντομεύσεων",
    "TITLE": {
      "OPEN_CONVERSATION": "Άνοιγμα συνομιλίας",
      "RESOLVE_AND_NEXT": "Επίλυση και μετακίνηση στην επόμενη",
      "NAVIGATE_DROPDOWN": "Πλοηγηθείτε στα αναπτυσσόμενα στοιχεία",
      "RESOLVE_CONVERSATION": "Επίλυση Συνομιλίας",
      "GO_TO_CONVERSATION_DASHBOARD": "Μεταβείτε στον Πίνακα Συνομιλίων",
      "ADD_ATTACHMENT": "Προσθήκη Συνημμένου",
      "GO_TO_CONTACTS_DASHBOARD": "Μετάβαση στον Πίνακα Επαφών",
      "TOGGLE_SIDEBAR": "Εναλλαγή πλευρικής μπάρας",
      "GO_TO_REPORTS_SIDEBAR": "Πλευρική μπάρα αναφορών",
      "MOVE_TO_NEXT_TAB": "Μετακίνηση στην επόμενη καρτέλα στη λίστα συνομιλιών",
      "GO_TO_SETTINGS": "Μετάβαση στις ρυθμίσεις",
      "SWITCH_TO_PRIVATE_NOTE": "Αλλαγή σε Ιδιωτική Σημείωση",
      "SWITCH_TO_REPLY": "Εναλλαγή σε απάντηση",
      "TOGGLE_SNOOZE_DROPDOWN": "Εναλλαγή αναβολής dropdown",
      "AI_ASSIST_MENU": "Βοήθεια AI",
      "AI_ASSIST_GRAMMAR": "Διόρθωση γραμματικής",
      "AI_ASSIST_UNIFY_LANG": "Ενοποίηση γλώσσας μηνύματος"
    }
  }
}
